import React, { useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import { Grid } from "@mui/material";
import Loader from "../../Layout/Loader";
import Table from "../../Components/common/tableWithBackEndPagination";
import axios from "axios";
import instance from "../../axios";
import { checkFloteNumber, checkPrivileges, showDates } from "../../Helpers";
import { toast } from "react-toastify";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";
import EnhancedTable from "./Table";
import { useSelector } from "react-redux";
import { printWorkshopPurchaseOrderPdf } from "../../Components/Documents";
const createRowDefinition = (translate) => [

         {
        id: "poNumber",
        numeric: false,
        disablePadding: false,
        label: translate("soNumber"),
    },
         {
        id: "poRefNumber",
        numeric: false,
        disablePadding: false,
        label: translate("soRefNumber"),
    },
    {
        id: "contractNumber",
        numeric: false,
        disablePadding: false,
        label: translate("contractNumber"),
    },
    {
        id: "attributes.counts",
        numeric: false,
        disablePadding: false,
        label: translate("dnsCount"),
    },
    {
        id: "attributes.estPrice",
        numeric: false,
        disablePadding: false,
        label: translate("estPrice"),
    },
    {
        id: "attributes.requestedBy",
        numeric: false,
        disablePadding: false,
        label: translate("requestedBy"),
    },
    // {
    //     id: "attributes.approvedBy",
    //     numeric: false,
    //     disablePadding: false,
    //     label: translate("responseBy"),
    // },
    {
        id: "created",
        numeric: false,
        disablePadding: false,
        label: translate("createdDate"),
    },
        {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: translate("status"),
    },
    {
        id: "viewInvoice",
        numeric: false,
        disablePadding: false,
        label: translate("purchaseOrder") || "PO",
        hide: false,
    },
];
const buildQuery = (filters) => {
    let qs = "";

    if (filters?.searchValue) qs += `&deliveryNoteNumber=${filters.searchValue}`;
    if (filters?.searchPlateNumber) qs += `&plateNumber=${filters.searchPlateNumber}`;
    if (filters?.from) qs += `&from=${filters.from}`;
    if (filters?.to) qs += `&to=${filters.to}`;
    if (filters?.verticals) qs += filters.verticals;

    return qs;
};
const buildUrl = (selectedOrder, page, perPage, filters) => {
    const query = buildQuery(filters);
    return `/api/poinvoices/getpoitems?poReqId=${selectedOrder}&page=${page}&limit=${perPage}${query}`;
};
const columns = [
    { id: "deliveryNoteNumber", numeric: false, disablePadding: false, label: "deliveryNoteNo" },
    // { id: "contractNumber", numeric: false, disablePadding: false, label: "contractNumber" },
    { id: "plateNumber", numeric: false, disablePadding: false, label: "plateNumber" },
    { id: "attributes.saleTotal", numeric: false, disablePadding: false, label: "totalAmount" },
    { id: "attributes.saleVat", numeric: false, disablePadding: false, label: "VAT Amount" },
    { id: "attributes.saleNet", numeric: false, disablePadding: false, label: "amount" },
    { id: "serviceDate", numeric: false, disablePadding: false, label: "serviceDate" },
    { id: "invoiceMade", numeric: false, disablePadding: false, label: "invoiced" },


];

const PoRequest = forwardRef((props,ref) => {
    const logInUser = useSelector((state) => state.logInUsers)
    const cancelSourceRef = useRef(null)
    const [saleOrderFilter, setSaleOrderFilter] = useState({
        fromDate: "",
        toDate: "",
        searchValue: "",
        searchPlateNumber: "",
        selectedDateTime: ""
    });
    const [showSingleOrderTable, setShowSingleOrderTable] = useState(false)
    const [singleSelectedOrder, setSingleSelectedOrder] = useState(null)
    const [isFetchingSaleItems, setIsFetchingSaleItems] = useState(false);
    const [itemPagination, setItemPagination] = useState({ items: [] });
    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [selectedPoRequest, setSelectedPoRequest] = useState(null)
    const [isDeletePoRequest, setIsDeletePoRequest] = useState(false)
    // po item delete
    const [deleteOrderItem, setDeleteOrderItem] = useState(null)
    const [isDeleteOrderItem, setIsDeleteOrderItem] = useState(false)
    const timezone = logInUser?.attributes?.timezone || "Asia/Riyadh";
    const [searchParams, setSearchParams] = useState({
    to: null,
    from: null,
    account: [],
    vehicle: [],
    poNumber:"",
    poRefNumber:""
  });

useImperativeHandle(ref, () => ({
  getPoRequests: async (params) => {
    setSearchParams((prev)=>({
        ...prev,
        ...params
    }))
    setPage(1)
  }
}));

const getPoRequests = async () => {
  try {
    setLoader(true);
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (searchParams?.to && searchParams?.from) {
      params.append("to", searchParams.to);
      params.append("from", searchParams.from);
    }
    if(props.creationMode){
        params.append("creationMode",props.creationMode)
    }
    


if (searchParams?.account?.length) {
  const accountsArray = Array.isArray(searchParams.account)
    ? searchParams.account
    : searchParams.account.toString().replace(/^&cn=/, "").split("&cn="); 

  accountsArray.forEach(cn => {
    if (cn) params.append("cn", cn);
  });
}


if (searchParams?.vehicle?.length) {
  const vehiclesArray = Array.isArray(searchParams.vehicle)
    ? searchParams.vehicle
    : searchParams.vehicle.toString().replace(/^&vehicleId=/, "").split("&vehicleId=");

  vehiclesArray.forEach(id => {
    if (id) params.append("vehicleId", id);
  });
}

if (searchParams?.status?.length > 0) {
  const statusArray = Array.isArray(searchParams.status)
    ? searchParams.status
    : [searchParams.status];

  statusArray.forEach(s => {
    if (s !== undefined && s !== null) {
      params.append("status", s);
    }
  });
}

if(searchParams?.poNumber){
    params.append("poNumber",searchParams.poNumber)
}
if(searchParams?.poRefNumber){
    params.append("poRefNumber",searchParams.poRefNumber)
}


    const url = `/api/poinvoices/getporequests?${params.toString()}`;
    const response = await instance.get(url);
    setRows(response);
    setTotal(response.data.total);
  } catch (err) {
    console.error("API error", err);
  } finally {
    setLoader(false);
  }
};


    useEffect(() => {
        getPoRequests();
    }, [searchParams,page, limit,props.triggerApi,props.creationMode]);

    const handleChangePage = (newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (e) => setLimit(e);


    const setPagination = () => {
        let paginationData;
        paginationData = { ...rows };
        let lastPage = paginationData.total / limit;
        let IsFloate = checkFloteNumber(lastPage);
        delete paginationData.data;
        paginationData.pageSize = limit;
        paginationData.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
        return paginationData;
    };

    const deletePoRequest = async () => {
        try {
            const result = await axios.delete(`/api/poinvoices/${selectedPoRequest.id}`);

            if (result?.data?.status === "success") {
                toast.success(props.translate("POrequest Deleted"));
                setSelectedPoRequest("");
                setIsDeletePoRequest(false);
                getPoRequests();
            } else {
                toast.error(props.translate(result?.data?.message || "Something went wrong"));
            }

        } catch (error) {
            const msg =
                error?.response?.data?.message ||
                error?.message ||
                "Server error";

            toast.error(props.translate(msg));
        }
    };

    const removeEnable = (selected) => {
        if (selected[0]) {
            setSelectedPoRequest(selected[0])
            setIsDeletePoRequest(true)
        }
    };

    const handleCancelPoRequest = () => {
        setIsDeletePoRequest(false)
    };
    // poiItems
    const handleOpenSingleOrderDns = (selectedPo) => {
        setSingleSelectedOrder(selectedPo)
        setShowSingleOrderTable(true)
        fetchData(selectedPo?.id, 1, pageSize, true);

    }
    const handleCancelSingleOder = () => {
        setShowSingleOrderTable(false)
        setSaleOrderFilter((prev) => ({
            ...prev,
            from: "",
            fromDate: "",
            searchPlateNumber: "",
            searchValue: "",
            selectedDateTime: "",
            to: "",
            toDate: ""
        }))
    }
    const handleClearSingleOrderFilter = () => {
        setSaleOrderFilter((prev) => ({
            ...prev,
            from: "",
            fromDate: "",
            selectedDateTime: null,
            to: "",
            toDate: ""
        }));
    };

    const handleSearch = () => {
        const selectedOrder = singleSelectedOrder?.id
        fetchData(selectedOrder, currentPage, pageSize, true);
    }
    const handleSaleOrderFilter = (name, value) => {
        setSaleOrderFilter((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleDateTime = (e, date) => {
        showDates(e, date, props, setSaleOrderFilter);
    };

    const onRowsPerPageChange = (size) => {
        const selectedOrder = singleSelectedOrder?.id
        setPageSize(size);
        setCurrentPage(1);
        fetchData(selectedOrder, 1, size, true);

    };

    const onPageChange = (page) => {
        const selectedOrder = singleSelectedOrder?.id
        setCurrentPage(page);
        fetchData(selectedOrder, page, pageSize, true);

    };

    const fetchData = useCallback(
        async (selectedOrder, page = currentPage, perPage = pageSize, reset = false) => {
            if (cancelSourceRef.current) {
                cancelSourceRef.current.cancel("Cancelled previous request");
            }
            cancelSourceRef.current = axios.CancelToken.source();

            const url = buildUrl(selectedOrder, page, perPage, saleOrderFilter);
            setIsFetchingSaleItems(true);
            try {
                const res = await axios.get(url, {
                    cancelToken: cancelSourceRef.current.token,
                });
                console.error("res", res)
                const responseData = res.data?.data || {};
                const list = responseData.data || [];
                const updatedItems = list.map((item) => ({
                    ...item,
                    check: false,
                }));
                setItemPagination((prevState) => ({
                    ...prevState,
                    page: responseData.page,
                    pageSize: responseData.pageSize,
                    total: responseData.total,
                    hasNext: responseData.hasNext,
                    items: reset ? updatedItems : [...prevState.items, ...updatedItems]
                }));
            } catch (err) {
                if (!axios.isCancel(err)) console.error(err);
            } finally {
                setIsFetchingSaleItems(false);
            }
        },
        [
            saleOrderFilter,
            singleSelectedOrder,
            currentPage,
            pageSize,
        ]
    );

    const approvePorequestItems = async () => {
        try {
            const result = await axios.get(`api/poinvoices/generatepoinvoice/${singleSelectedOrder?.id}`);
            if (result?.data?.status === "success") {
                getPoRequests()
                toast.success(props.translate("SoInvoiceGenerate Success"));
            } else {
                toast.error(props.translate(result?.data?.message || "Something went wrong"));
            }
        } catch (error) {
            console.error("Delete PO Request Error:", error);
            const msg =
                error?.response?.data?.message ||
                error?.message ||
                "Server error";
            toast.error(props.translate(msg));
        } finally {
            handleCancelSingleOder()
        }
    };

        const rejectPorequestItems = async () => {
        try {
            const result = await axios.get(`api/poinvoices/rejectpoinvoice/${singleSelectedOrder?.id}`);
            if (result?.data?.status === "success") {
                getPoRequests()
                toast.success(props.translate("SoInvoiceReject Success"));
            } else {
                toast.error(props.translate(result?.data?.message || "Something went wrong"));
            }
        } catch (error) {
            console.error("Delete PO Request Error:", error);
            const msg =
                error?.response?.data?.message ||
                error?.message ||
                "Server error";
            toast.error(props.translate(msg));
        } finally {
            handleCancelSingleOder()
        }
    };

    // po item delete
    const handleDeleteSaleOrderItem = (data) => {
        setIsDeleteOrderItem(true)
        console.error(data[0])
        setDeleteOrderItem(data?.[0])
    }

    const handleCancelSaleOrderItem = () => {
        setIsDeleteOrderItem(false)
        setDeleteOrderItem(null)
    }

    const deletePorequestItem = async () => {
        try {
            const result = await axios.delete(`/api/poinvoices/poitems/${deleteOrderItem?.id}`);
            if (result?.data?.status === "success") {
        const selectedOrder = singleSelectedOrder?.id

        fetchData(selectedOrder, 1, pageSize, true);
                toast.success(props.translate("PoInvoice Delete Success"));
            } else {
                toast.error(props.translate(result?.data?.message || "Something went wrong"));
            }
        } catch (error) {
            const msg =
                error?.response?.data?.message ||
                error?.message ||
                "Server error";
            toast.error(props.translate(msg));
        } finally {
            handleCancelSaleOrderItem()
        }
    };

    return (
        <Grid mt={0}>
            <Grid>
                {loader ? (
                    <Loader />
                ) : (
                    <Table
                        rows={rows?.data || []}
                        rowDefinition={createRowDefinition(props.translate)}
                        pagination={setPagination()}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        serverTimezone={timezone}
                        timezone={timezone}
                        isEditable
                        canUpdate
                        canDelete
                        invoiceRow
                        hasAccessOfDelete={checkPrivileges("porequestDelete")}
                        onDelete={removeEnable}
                        isShowPoRequestItems
                        handleOpenSingleOrderDns={handleOpenSingleOrderDns}
                        onShowModal={handleOpenSingleOrderDns}
                        poRequest
                        downloadInvoice={(item, type) => {
                            if (type) return;
                            try {
                                printWorkshopPurchaseOrderPdf(item, {
                                    logInUser,
                                });
                            } catch (e) {
                                toast.error(
                                    props.translate("somethingWentWrong"),
                                );
                            }
                        }}
                    />
                )}
            </Grid>

            {isDeletePoRequest && (
                <>
                    <ConfirmDialoag
                        onCancel={handleCancelPoRequest}
                        onOk={deletePoRequest}
                        title={props.translate("areYouWantToDelete")}
                        children={selectedPoRequest?.deliveryNoteId}
                    />
                </>
            )}

            {isDeleteOrderItem && (
                <>
                    <ConfirmDialoag
                        onCancel={handleCancelSaleOrderItem}
                        onOk={deletePorequestItem}
                        title={props.translate("areYouWantToDelete")}
                        children={deleteOrderItem?.deliveryNoteNumber}
                    />
                </>
            )}
            {showSingleOrderTable &&
                <ConfirmDialoag
                    onCancel={handleCancelSingleOder}
                    onOk={approvePorequestItems}
                    hideCancel
                    showRejectButton
                    rejectText={"Reject"}
                    OkText={'Approve'}
                    onReject={rejectPorequestItems}
                    disabled={(singleSelectedOrder?.attributes?.approvedBy||singleSelectedOrder?.attributes?.rejectedBy) && checkPrivileges("porequestPoInvoiceGenerate")}
                    CancelText={"Close"}
                    maxWidth={"lg"}
                    children={
                        <EnhancedTable
                            rows={itemPagination.items}
                            rowDefinition={columns}
                            title="Sale Order DNs"
                            searchable
                            handleClearSingleOrderFilter={handleClearSingleOrderFilter}
                            createButton={false}
                            showCheckbox={false}
                            isEditable={true}
                            canUpdate={false}
                            canDelete={singleSelectedOrder?.status===0}
                            onDelete={handleDeleteSaleOrderItem}
                            canViewDn={true}
                            canDownloadPdf={true}
                            isSaleOrderHeader={true}
                            handleSearch={handleSearch}
                            handleDateTime={handleDateTime}
                            saleOrderFilter={saleOrderFilter}
                            handleSaleOrderFilter={handleSaleOrderFilter}
                            onPageChange={onPageChange}
                            page={currentPage}
                            totalData={itemPagination.total}
                            rowsPerPage={pageSize}
                            isLoading={isFetchingSaleItems}
                            onRowsPerPageChange={onRowsPerPageChange}
                            translate={props.translate}
                        />
                    }
                />
            }
        </Grid>
    );
})

export default PoRequest;
